export default __webpack_public_path__ + "static/media/introduction_mobile_background.966df7fc.jpg";